<div class="w-full border rounded-lg p-4">
  <span>Webhook Delivery History</span>
    <cdk-virtual-scroll-viewport
      itemSize="10"
      class="scroll-viewport"
      (scrolledIndexChange)="onScroll()"
      style="height: 500px; width: 100%"
    >
      <nz-table
        #nzTable
        class="mt-2"
        [nzData]="deliveryHistory.list"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        [nzLoading]="isLoading()"
      >
        <thead>
          <tr>
            <th nzWidth="120px">Status</th>
            <th nzWidth="200px" nzColumnKey="date" [nzSortFn]="sortByDate">
              Date Created
            </th>
            <th nzWidth="200px">History ID</th>
            <th nzWidth="100px">Attempts</th>
            <th nzWidth="100px">Action</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *cdkVirtualFor="let data of deliveryHistory.list">
            <tr>
              <td nzWidth="120px">
                <span
                  [ngClass]="handleClassStatus(data.status)"
                >
                  {{ data.status | titlecase }}
                </span>
              </td>
              <td nzWidth="200px">
                <span>{{ data.created_at | date : "dd MMM yyyy HH:mm a" }}</span>
              </td>
              <td nzWidth="200px">
                <span>{{ data.history_id }}</span>
              </td>
              <td nzWidth="100px">
                <span>{{ data.attempt }}</span>
              </td>
              <td nzWidth="100px">
                <button nz-button nzType="primary" (click)="handleResendWebhook(data.history_id)">Resend</button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </cdk-virtual-scroll-viewport>
</div>
